export default "__VITE_ASSET__3a30ab39__"